<!-- ========== Left Sidebar Start ========== -->

<div class="vertical-menu">
  <!-- LOGO -->
  <div class="navbar-brand-box">
    <a [routerLink]="['/']" class="logo logo-dark">
      <span class="logo-sm">
        <img src="assets/images/logoVB.png" alt="" height="28" />
      </span>
      <span class="logo-lg">
        <img src="assets/images/logoHB.png" alt="" height="40" />
      </span>
    </a>

    <a [routerLink]="['/']" class="logo logo-light">
      <span class="logo-sm">
        <img src="assets/images/logoVB.png" alt="" height="28" />
      </span>
      <span class="logo-lg">
        <img src="assets/images/logoHB.png" alt="" height="40" />
      </span>
    </a>
  </div>
  <button
    type="button"
    class="btn btn-sm px-3 font-size-16 header-item waves-effect vertical-menu-btn"
    (click)="toggleMobileMenu($event)"
  >
    <i class="fa fa-fw fa-bars"></i>
  </button>
  <ngx-simplebar
    class="h-100 sidebar-menu-scroll"
    #componentRef
    *ngIf="!isCondensed"
  >
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </ngx-simplebar>

  <ngx-simplebar class="sidebar-menu-scroll" #componentRef *ngIf="isCondensed">
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </ngx-simplebar>
</div>

<ng-template #contentTemplate>
  <!--- Sidemenu -->
  <div id="sidebar-menu">
    <!-- Left Menu Start -->
    <ul class="metismenu list-unstyled" id="side-menu" #sideMenu>
      <li class="menu-title">Home</li>
      <ng-container>
        <li>
          <a
            class="side-nav-link-ref"
            routerLink="/dashboard"
            [routerLink]="['/']"
          >
            <i class="dripicons dripicons-graph-pie"></i>
            <span> Dashboard</span>
          </a>
        </li>
        <li>
          <a
            class="side-nav-link-ref"
            routerLink="/profile"
            routerLinkActive="active"
          >
            <i class="bx uil-user"></i>
            <span> Mi perfil</span>
          </a>
        </li>
        <li>
          <a
            class="side-nav-link-ref"
            routerLink="/mispagos"
            routerLinkActive="active"
          >
            <i class="bx uil-bill"></i>
            <span> Mis pagos</span>
          </a>
        </li>
        <li>
          <a
            class="side-nav-link-ref"
            routerLinkActive="active"
            routerLink="/faqs"
          >
            <i class="dripicons dripicons-question"></i>
            <span> FAQ's</span>
          </a>
        </li>
        <li>
          <a
            class="side-nav-link-ref"
            routerLinkActive="active"
            routerLink="/asociados"
          >
            <i class="dripicons dripicons-user-group"></i>
            <span> Asociados</span>
          </a>
        </li>
      </ng-container>

      <li *ngIf="nAccess" class="menu-title">System</li>
      <ng-container *ngFor="let item of access">
        <li>
          <a
            href="javascript:void(0);"
            class="is-parent"
            [ngClass]="{ 'has-arrow': !item.badge, 'has-dropdown': item.badge }"
          >
            <i class="{{ item.icon }}" *ngIf="item.icon"></i>
            <span> {{ item.name }}</span>
          </a>

          <ul class="sub-menu" aria-expanded="false">
            <li *ngFor="let subitem of item.tabs">
              <a
                [routerLink]="subitem.route"
                class="side-nav-link-ref"
                routerLinkActive="active"
              >
                {{ subitem.name }}
              </a>
            </li>
          </ul>
        </li>
      </ng-container>
    </ul>
  </div>
</ng-template>
